var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    attrs: {
      "className": "header--light"
    }
  }, [_c('sub-visual', {
    attrs: {
      "sh": "인재채용",
      "tabActive": "채용절차",
      "bg": "/images/sub/visual/sv4-4.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v("채용절차")])]), _c('v-tabs', {
    staticClass: "tab tab--block mb-50 mb-md-70 mb-lg-80"
  }, [_c('v-tab', {
    staticClass: "tab__li",
    attrs: {
      "to": "/recruitment/procedure"
    }
  }, [_vm._v("본사")]), _c('v-tab', {
    staticClass: "tab__li",
    attrs: {
      "to": "/recruitment/procedure-branch"
    }
  }, [_vm._v("지점")])], 1), _c('div', [_c('h5', {
    staticClass: "bar-text d-flex flex-column flex-lg-row align-lg-center mb-30 mb-lg-20"
  }, [_vm._v(" 본사 "), _c('span', {
    staticClass: "color-grey-7 page-text--sm d-inline-block mt-4 mt-0 ml-lg-20 font-weight-regular"
  }, [_vm._v("강남구 역삼동에 위치한 세일즈웍스 코리아 본사에서 근무합니다.")])]), _c('div', {
    staticClass: "pt-12 pt-lg-36 border-top border-color-black border-2 w-100"
  }, [_c('v-img', {
    staticClass: "d-block d-md-none mb-16 mb-lg-30",
    attrs: {
      "src": "/images/sub/recruitment/procedure/process1-mo.jpg",
      "max-width": "672"
    }
  }), _c('div', {
    staticClass: "process process4 d-none d-md-flex justify-space-between text-center mb-16 mb-lg-30"
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "process-icon process-icon1-4 mb-8 mb-lg-14"
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/recruitment/procedure/process-icon1-4.png",
      "contain": "",
      "max-width": "60"
    }
  })], 1), _c('p', {
    staticClass: "page-text--sm font-weight-bold"
  }, [_vm._v(" 서류 지원 ")])]), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('div', {
    staticClass: "process-icon process-icon2-4 mb-8 mb-lg-14"
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/recruitment/procedure/process-icon2-4.png",
      "contain": "",
      "max-width": "60"
    }
  })], 1), _c('p', {
    staticClass: "page-text--sm font-weight-bold"
  }, [_vm._v(" 1차 면접 ")])]), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "process-icon process-icon3-4 mb-8 mb-lg-14"
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/recruitment/procedure/process-icon3-4.png",
      "contain": "",
      "max-width": "60"
    }
  })], 1), _c('p', {
    staticClass: "page-text--sm font-weight-bold"
  }, [_vm._v(" 2차 면접 ")])]), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('div', {
    staticClass: "process-icon process-icon4-4 mb-8 mb-lg-14"
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/recruitment/procedure/process-icon4-4.png",
      "contain": "",
      "max-width": "80"
    }
  })], 1), _c('p', {
    staticClass: "page-text--sm font-weight-bold"
  }, [_vm._v(" 최종 합격 ")])])]), _c('div', {
    staticClass: "w-100 bg-grey pa-20 px-md-30 py-md-20 mb-30 mb-lg-60"
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-16 color-grey-7"
  }, [_vm._v(" * 서류 합격 시 면접 일정을 개별 연락드립니다. "), _c('br'), _vm._v(" * 채용 절차는 부서에 따라 차이가 있을 수 있습니다. ")])]), _c('div', {
    staticClass: "border-top border-color-light mb-50 mb-lg-80"
  }, [_c('underline-list', {
    attrs: {
      "tit": "서류 지원"
    }
  }, [_vm._v(" 채용 사이트를 통해 이력서와 자기소개서를 제출합니다. "), _c('span', {
    staticClass: "color-grey-a"
  }, [_vm._v("(제출서류 부서별 상이)")])]), _c('underline-list', {
    attrs: {
      "tit": "면접 전형"
    }
  }, [_vm._v(" 부서의 팀장과 면접을 통해 지원자의 잠재 역량과 인성, 태도 등을 종합적으로 평가합니다. "), _c('span', {
    staticClass: "color-grey-a"
  }, [_vm._v("(직무에 따라 부서별 사전 테스트가 있을 수 있습니다.)")])]), _c('underline-list', {
    attrs: {
      "tit": "최종 합격"
    }
  }, [_vm._v(" 면접 후 최종 합격 시 개별 연락드립니다. ")])], 1), _c('div', {
    staticClass: "d-flex justify-center"
  }, [_c('arrow-btn', {
    staticClass: "mr-4 mr-lg-10",
    attrs: {
      "tit": "사람인에서 지원하기",
      "color": "primary",
      "link": "https://www.saramin.co.kr/zf_user/company-info/view-inner-recruit?csn=RWFleFZWa0VoWkNKVGNhQjlFSUdxZz09",
      "type": "href"
    }
  }), _c('arrow-btn', {
    attrs: {
      "tit": "잡코리아에서 지원하기",
      "color": "primary",
      "link": "https://www.jobkorea.co.kr/Recruit/Co_Read/Recruit/C/appcokoreaho",
      "type": "href"
    }
  })], 1)], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }